import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  max-width: fit-content;
  position: relative;
`;
